import { ReactElement } from "react";
import { useLocalization } from "@fluent/react";
import { DrawerCard } from "../../common";
import getPaymentTypeDrawerConfig from "../paymentTypeDrawerConfig";
import type { PaymentMetadataProps } from "../PaymentActivityDrawer";

type PaymentDetailsCardProps = {
  paymentActivity: API.FormattedPaymentActivity;
  paymentMetadata: PaymentMetadataProps | null;
  drawerConfig: ReturnType<typeof getPaymentTypeDrawerConfig>;
};

const PaymentDetailsCard = ({
  paymentActivity,
  paymentMetadata,
  drawerConfig,
}: PaymentDetailsCardProps): ReactElement | null => {
  const { l10n } = useLocalization();

  if (
    (!paymentMetadata && !paymentActivity.isReversal) ||
    !paymentActivity?.model
  ) {
    return null;
  }

  const config = drawerConfig[paymentActivity.model];
  if (!config) return null;

  const rows = config.paymentDetailsRows(
    paymentMetadata ?? {},
    paymentActivity.institutionAccount,
    paymentActivity,
  );

  return (
    <DrawerCard
      rows={rows.filter((row) => row[1])}
      title={l10n.getString("ach-payment-payment-details-title")}
    />
  );
};

export default PaymentDetailsCard;
